"use client";
import { Container, Row } from "react-bootstrap";
import "./ERPExpertiseSection.scss";
import Image from "next/image";

const ERPExpertiseSection = ({ expertise }) => {
  if (!expertise) return null;
  const { title, description, industries } = expertise;

  const rows = [
    industries.slice(0, 5),
    industries.slice(5, 9),
    industries.slice(9, 12),
  ];

  return (
    <section className="erp-expertise-section">
      <Container>
        <h2 className="erp-expertise-title">{title}</h2>
        <p className="erp-expertise-description">{description}</p>
        <div className="industry-wrapper">
          {rows.map((row, rowIndex) => (
            <div className="industry-row" key={rowIndex}>
              {row.map((item, index) => (
                <div className="industry-pill" key={index}>
                  <div className="icon-box">
                    <img src={item.icon.src} alt={item.title} />
                  </div>
                  <span>{item.title}</span>
                </div>
              ))}
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
};

export default ERPExpertiseSection;
